import React from "react";

/**
 * @typedef {import("./minMaxErrorMessageTypes").MessageProps} MessageProps
 */

/**
 *
 * @param {MessageProps} props
 * @returns {React.ReactElement|null}
 */
const Message = ({ displayMessage = false, message = "" }) =>
    displayMessage ? (
        <div className="col col--12 -text--center">
            <p className="-color--system-error">
                <strong>{message}</strong>
            </p>
        </div>
    ) : null;

export default Message;
